import { useState } from 'react';
import { Link } from 'react-router-dom';
import intl from 'react-intl-universal';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { Button } from '@getsynapse/design-system';
import { useFlags } from 'launchdarkly-react-client-sdk';
import RenderNoRecords from 'Atoms/NoRecords/NoRecords';
import { PATHS, V2_PATHS } from 'utils/constants';
import emptyStateImg from 'assets/images/search-empty-state.svg';
import { SelectOrganisationId } from 'state/Organization/organizationSlice';
import { selectIsBusinessUser, selectIsUserLd } from 'state/User/userSlice';
import config from 'config/Config';

const RequestsDefaultEmptyState = () => {
  const [isCopied, setIsCopied] = useState(false);
  const {
    advancedIntake = false,
    intakeAgentAccess = false,
    legacyIntake = false,
  } = useFlags();
  const isLdUser = useSelector(selectIsUserLd);
  const isBusinessUser = useSelector(selectIsBusinessUser);
  const canAccessIntakeAgent =
    intakeAgentAccess && (isLdUser || isBusinessUser);
  const effectiveAdvanced =
    advancedIntake || intakeAgentAccess || !legacyIntake;

  const businessLoginBaseUrl = config.get('businessLoginBaseUrl');
  const organizationId = useSelector(SelectOrganisationId);
  const portalUrl = businessLoginBaseUrl + organizationId;

  const copyToClipboard = () => {
    if (!portalUrl) return;

    navigator.clipboard.writeText(portalUrl);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 3000);
  };

  return (
    <tr data-testid='default-empty-state'>
      <td colSpan={13}>
        <RenderNoRecords
          imageSrc={emptyStateImg}
          caption={intl.getHTML('REQUESTS_LIST_PAGE.DEFAULT_EMPTY_STATE')}
          className='h-screen-minus-16rem'
        >
          <div className='flex mt-2'>
            {canAccessIntakeAgent && (
              <a href={V2_PATHS.AGENT_PAGE}>
                <Button variant='secondary'>
                  {intl.get('REQUESTS_LIST_PAGE.ADD_REQUEST_WITH_AGENT')}
                </Button>
              </a>
            )}
            {effectiveAdvanced ? (
              <Button
                className={classNames({ 'ml-2': canAccessIntakeAgent })}
                onClick={() => {
                  window.location.href = V2_PATHS.SELECT_REQUEST_TYPE;
                }}
              >
                {intl.get('REQUESTS_LIST_PAGE.ADD_REQUEST_BUTTON')}
              </Button>
            ) : (
              <Link to={PATHS.REQUEST_PAGE}>
                <Button
                  className={classNames({ 'ml-2': canAccessIntakeAgent })}
                >
                  {intl.get('REQUESTS_LIST_PAGE.ADD_REQUEST_BUTTON')}
                </Button>
              </Link>
            )}
            <Button
              className={classNames('ml-2 h-8 ', {
                'pointer-events-none': isCopied,
              })}
              iconName={isCopied ? 'checkmark-circle' : ''}
              iconColor='success-darker'
              variant='secondary'
              onClick={copyToClipboard}
            >
              {isCopied
                ? intl.get('REQUESTS_LIST_PAGE.LINK_COPIED')
                : intl.get('REQUESTS_LIST_PAGE.COPY_PORTAL_LINK')}
            </Button>
          </div>
        </RenderNoRecords>
      </td>
    </tr>
  );
};

export default RequestsDefaultEmptyState;
